import {BehaviorSubject} from 'rxjs';
import {Injectable} from '@angular/core';
@Injectable( { providedIn: 'root' } )
export class TitleBroadcastService {
    public title: BehaviorSubject<string>;
    constructor() {
        this.title = new BehaviorSubject<string>('Dashboard');
    }
}
